import { record } from '../ability/context';

const uuid = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
const identity = (value: unknown): void => {
  if (typeof value !== 'string' || !uuid.test(value)) throw new Error('ammunition:invalid-identity');
};
const integer = (value: unknown): void => {
  if (!Number.isSafeInteger(value)) throw new Error('ammunition:invalid-integer');
};

/** Check the completed native changes, including late charged-item consumption, before transport publication. */
export function assertAmmunitionValues(value: unknown): void {
  if (value == null) return;
  if (!Array.isArray(value)) throw new Error('ammunition:invalid-changes');
  for (const entry of value) {
    const change = record(entry), before = record(change?.before), after = record(change?.after);
    identity(change?.inventory_id); identity(before?.possess_id);
    for (const part of [before, after]) { integer(part?.item_qty); integer(part?.inventory_deleted); }
    if (change?.recovery == null) continue;
    const r = record(change.recovery);
    identity(r?.inventory_id); identity(r?.possess_id);
    if (typeof r?.created !== 'boolean') throw new Error('ammunition:invalid-recovery');
    integer(r.item_qty);
    for (const key of ['x_pos', 'y_pos', 'z_pos'])
      if (typeof r[key] !== 'number' || !Number.isFinite(r[key])) throw new Error('ammunition:invalid-position');
    if (r.inventory_id !== change.inventory_id && !r.created) {
      const snapshot = record(r.before);
      identity(snapshot?.possess_id); integer(snapshot?.inventory_deleted); integer(r.before_qty);
    }
  }
}
